const crudConfig = {
    endpoint: 'criteriapredicateparts',
    primaryKey: 'partId',
    functions: {
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            args: ['partId'],
            // firstArgSlug: true,
            query: {
                // filter: 'partId=#@partId@#',
                expand: 'CdsListItemDTO'
            }
        },
        update: {
            method: 'put',
            returnType: 'Object',
            service: 'cds',
            args: ['partId']
        }
    },
    metadata: {
        endpoint: 'cds/criteriapredicateparts',
        functions: {
            fetch: {
                method: 'get',
                returnType: 'Object',
                service: 'cds',
                args: [],
                query: {}
            }
        }
    }
};
export default crudConfig;
